import { Controller } from "@hotwired/stimulus"

// Smaller differences between layout and visible viewport are toolbars, not the keyboard
const KEYBOARD_MIN_HEIGHT = 150

// Chat in a sheet: the sheet fills the visible viewport, so the composer sits right above the keyboard (fixed
// elements would stay behind it), and the messages keep to the newest one at the bottom.
export default class extends Controller {
  static targets = ["messages"]

  connect() {
    this.fit = this.fit.bind(this)
    this.scrollToEnd = this.scrollToEnd.bind(this)

    window.visualViewport?.addEventListener("resize", this.fit)
    window.visualViewport?.addEventListener("scroll", this.fit)
    this.element.addEventListener("shown.bs.modal", this.scrollToEnd)
    this.observer = new MutationObserver(this.scrollToEnd)
    this.observer.observe(this.messagesTarget, { childList: true, subtree: true })
    this.fit()
  }

  disconnect() {
    window.visualViewport?.removeEventListener("resize", this.fit)
    window.visualViewport?.removeEventListener("scroll", this.fit)
    this.element.removeEventListener("shown.bs.modal", this.scrollToEnd)
    this.observer.disconnect()
  }

  fit() {
    const viewport = window.visualViewport
    if (!viewport) return

    this.element.style.setProperty("--chat-sheet-top", `${viewport.offsetTop}px`)
    this.element.style.setProperty("--chat-sheet-height", `${viewport.height}px`)
    this.element.classList.toggle("chat-sheet--keyboard", window.innerHeight - viewport.height > KEYBOARD_MIN_HEIGHT)
    this.scrollToEnd()
  }

  scrollToEnd() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }
}
